import { render, staticRenderFns } from "./keywordsEdit.vue?vue&type=template&id=e92f5c9e&"
import script from "./keywordsEdit.vue?vue&type=script&lang=js&"
export * from "./keywordsEdit.vue?vue&type=script&lang=js&"
import style0 from "./keywordsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports